import { useMutation } from '@apollo/client';
import type {
  DeleteWizardMutation,
  DeleteWizardMutationVariables,
} from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteWizardDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureFlagEnabled } from '@/hooks/useIsFeatureFlagEnabled';
import { evictField } from '@/utils/graphqlUtils';

import { useDeleteWizardTRPC } from './useDeleteWizardTRPC';

export const useDeleteWizard = () => {
  const trpcEnabled = useIsFeatureFlagEnabled('trpc');

  // GraphQL mutation (legacy)
  const [deleteWizardGraphQL, graphqlState] = useMutation(
    DeleteWizardDocument,
    {
      update: (cache) => {
        evictField(cache, 'wizard');
      },
    }
  );

  // tRPC mutation
  const trpcMutation = useDeleteWizardTRPC();

  const deleteWizard = async (
    variables: DeleteWizardMutationVariables
  ): Promise<DeleteWizardMutation> => {
    if (trpcEnabled) {
      return trpcMutation.deleteWizard({ RiskId: variables.RiskId });
    }

    const result = await deleteWizardGraphQL({ variables });
    if (!result.data) {
      throw new Error('Failed to delete wizard');
    }

    return result.data;
  };

  // Return appropriate state based on feature flag
  if (trpcEnabled) {
    return {
      deleteWizard,
      loading: trpcMutation.loading,
      error: trpcMutation.error,
    };
  }

  return {
    deleteWizard,
    loading: graphqlState.loading,
    error: graphqlState.error,
  };
};
